/**
 * @fileoverview Input/output schemas for world-species-snapshotter-v3.
 *
 * This agent updates a world species' state after a chapter has been written.
 */

import { z } from 'zod';
import { BaseFlowInputSchema } from '@/ai/agents/base-schema';
import { AGENT_SCHEMA_OBJECTS } from '@/ai/agents/prompt-variables';
import { WorldSpeciesAttributesV3Schema, WorldSpeciesSnapshotV3Schema } from '@/domains/world-building/schemas';

export const InputSchema = z.object({
  ...BaseFlowInputSchema.shape,
  ...AGENT_SCHEMA_OBJECTS.loreContext.schema.shape,
  worldSpecies: z.object({
    id: z.string(),
    name: z.string(),
    type: z.literal('species'),
    element: z.enum(['creature', 'race', 'flora']),
    initialDescription: z.string().optional(),
  }).describe('The world species being snapshotted.'),
  previousSnapshot: WorldSpeciesSnapshotV3Schema.optional().describe('The species state before this chapter.'),
  chapterContent: z.string().describe('The full content of the chapter to analyze.'),
  chapterNumber: z.number().describe('The chapter number for snapshot metadata.'),
});

export type Input = z.infer<typeof InputSchema>;

export const OutputSchema = WorldSpeciesAttributesV3Schema.extend({
  notPresentInChapter: z.boolean().optional().describe('True if the species was not mentioned or relevant in this chapter.'),
});

export type Output = z.infer<typeof OutputSchema>;
